'use client';

import { sendGTMEvent } from '@next/third-parties/google';
import cx from 'classnames';

import { PageType } from '../../constants';
import { ANALYTICS_TAG, useAnalyticsContext } from '../Analytics/AnalyticsProvider';
import { FORM_LAUNCH_STORAGE_KEY } from '../MealPlanForm/utils';

import { FormAnchorLink } from './FormAnchorLink';
import styles from './styles.module.scss';

export const GoToFormButton = ({
  stickyOnMobile,
  hiddenOnMobile,
  pageType,
  className,
}: {
  stickyOnMobile?: boolean;
  hiddenOnMobile?: boolean;
  pageType: PageType;
  className?: string;
}) => {
  const { getEventCategory, track } = useAnalyticsContext();

  const handleStartForm = () => {
    // Store the current URL path to return to on form exit
    // localStorage is used because there's no shared providers amongst the different pages
    localStorage.setItem(FORM_LAUNCH_STORAGE_KEY, window.location.pathname);

    const eventCategory = getEventCategory(pageType);
    track(ANALYTICS_TAG.NAME_BUTTON_CLICKED, {
      eventCategory,
      eventAction: ANALYTICS_TAG.EVENT_CLICK,
      eventLabel: 'get-real-now',
    });
    sendGTMEvent({
      event: ANALYTICS_TAG.NAME_BUTTON_CLICKED,
      eventCategory,
      eventAction: ANALYTICS_TAG.EVENT_CLICK,
      eventLabel: 'get-real-now',
    });
  };

  return (
    <div
      className={cx(styles.startButtonContainer, className, {
        [styles.stickyOnMobile]: stickyOnMobile,
        [styles.hiddenOnMobile]: hiddenOnMobile,
      })}
    >
      <FormAnchorLink
        onClick={handleStartForm}
        text="Build your plan"
        className={styles.startButton}
      />
    </div>
  );
};
